var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDopaminergicDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 952.429,
    height: 646.413,
    viewBox: "0 0 952.429 646.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ab,.ad,.ag,.aj,.d{fill:none;}.b{fill:#9e9fad;}.c,.m,.n,.o,.p,.q{fill:#3d3f5b;}.ab,.ad,.d,.t,.v,.x,.y,.z{stroke:#3d3f5b;}.ab,.ad,.ag,.d,.t,.v,.x,.y,.z{stroke-miterlimit:10;}.d{stroke-dasharray:6 4.5;}.e{fill:#f2cc8e;}.f,.k,.l,.r{fill:#fff;}.g{clip-path:url(#a);}.h{fill:#f4f1de;}.i,.t,.v,.x,.y{fill:#e17a5f;}.j,.z{fill:#f0bdaf;}.k{font-size:17px;}.k,.l,.m,.n,.r{font-family:MyriadPro-Regular, Myriad Pro;}.l{font-size:16.5px;}.m,.o,.q,.r{font-size:16px;}.n,.p{font-size:15px;}.o{font-family:ArialMT, Arial;}.p,.q{font-family:MyriadPro-Semibold, Myriad Pro;font-weight:600;}.s{clip-path:url(#b);}.t,.v,.x{stroke-linejoin:bevel;}.t{stroke-width:0.75px;}.u{clip-path:url(#e);}.v{stroke-width:0.605px;}.w{clip-path:url(#ao);}.x{stroke-width:0.338px;}.aa{clip-path:url(#by);}.ac{clip-path:url(#ca);}.ad{stroke-width:0.651px;}.ae{clip-path:url(#ch);}.af{fill:#eaa592;}.ag{stroke:#e17a5f;}.ah{fill:#d78064;}.ai{fill:#b2b2bd;}.aj{stroke:#fff;stroke-linecap:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 113.376,
    height: 73.089,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23.719,
    height: 21.351,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.13,
    height: 17.219,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.688,
    height: 9.621,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.638,
    height: 22.569,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14.746,
    height: 14.702,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 36.917,
    height: 23.799,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-137.14 -289.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.923,272.207H189.657A11.391,11.391,0,0,1,178.27,260.82V224.427a11.391,11.391,0,0,1,11.387-11.387H338.923a11.391,11.391,0,0,1,11.387,11.387V260.82A11.384,11.384,0,0,1,338.923,272.207Z",
    transform: "translate(234.795 652.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M418.61,272.207H259.657A11.391,11.391,0,0,1,248.27,260.82V224.427a11.391,11.391,0,0,1,11.387-11.387H418.61A11.391,11.391,0,0,1,430,224.427V260.82A11.384,11.384,0,0,1,418.61,272.207Z",
    transform: "translate(67.965 179.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M586.7,669.09H151.6a60.174,60.174,0,0,1-60.17-60.17V233.26a60.174,60.174,0,0,1,60.17-60.17H586.7a60.174,60.174,0,0,1,60.17,60.17v375.65A60.176,60.176,0,0,1,586.7,669.09Z",
    transform: "translate(46.21 173.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M318,445.049A31.516,31.516,0,0,0,292.78,457.62a36.57,36.57,0,1,0,1.093,39.434A31.6,31.6,0,1,0,318,445.049Z",
    transform: "translate(64.871 210.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M345.158,476.109a27.7,27.7,0,0,1-52.791,11.729,32.04,32.04,0,1,1-.6-22.08,27.7,27.7,0,0,1,53.394,10.351Z",
    transform: "translate(65.42 210.903)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(726.794 523.138)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 56.688,
    cy: 36.545,
    rx: 56.688,
    ry: 36.545,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-31.026-16.794V.972a2.507,2.507,0,0,0,2.518,2.518h1.679A2.507,2.507,0,0,0-24.312.972V-15.01a7.523,7.523,0,0,1,5.49-7.239h0A7.5,7.5,0,0,1-9.309-15.01V3.454l2.9-.49A2.547,2.547,0,0,0-4.308.482V-17.423a10,10,0,0,1,10-10h0a10,10,0,0,1,10,10V.972a2.507,2.507,0,0,0,2.518,2.518h0A2.507,2.507,0,0,0,20.731.972V-6.442a11.934,11.934,0,0,1,15.842-11.3h0a8.6,8.6,0,0,1,5.805,8.183V1.811H46.54V-3.54a2.5,2.5,0,0,1,4.266-1.784l2.833,2.833V8.071a7.726,7.726,0,0,1-2.273,5.49h0a8.565,8.565,0,0,1-14.618-6.05V-3.435A2.507,2.507,0,0,0,34.23-5.953H31.782a2.507,2.507,0,0,0-2.518,2.518V28.389A9.85,9.85,0,0,1,19.4,38.251h0A9.85,9.85,0,0,1,9.54,28.389V-5.393A2.507,2.507,0,0,0,7.022-7.911h0A2.507,2.507,0,0,0,4.5-5.393V30.312a9.3,9.3,0,0,1-9.3,9.3h0a9.3,9.3,0,0,1-9.3-9.3V-3.75a2.507,2.507,0,0,0-2.518-2.518h-.8A2.507,2.507,0,0,0-19.94-3.75V6.112a10.782,10.782,0,0,1-18.395,7.624h0a8.131,8.131,0,0,1-2.413-5.91c.1-8.953.315-17.451-.035-17.1C-41.168-8.89-31.026-16.794-31.026-16.794Z",
    transform: "translate(51.029 32.741)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 37.076,
    cy: 37.076,
    r: 37.076,
    transform: "translate(232.768 532.648)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 32.499,
    cy: 32.499,
    r: 32.499,
    transform: "translate(237.346 537.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 37.076,
    cy: 37.076,
    r: 37.076,
    transform: "translate(323.444 532.648)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 32.499,
    cy: 32.499,
    r: 32.499,
    transform: "translate(328.021 537.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 30.62,
    cy: 30.62,
    r: 30.62,
    transform: "translate(471.248 550.413)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 26.839,
    cy: 26.839,
    r: 26.839,
    transform: "translate(475.029 554.192)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 25.393,
    cy: 17.172,
    rx: 25.393,
    ry: 17.172,
    transform: "translate(476.532 744.54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 16.181,
    cy: 12.48,
    rx: 16.181,
    ry: 12.48,
    transform: "translate(481.781 748.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M661.2,617.723h0a47.232,47.232,0,0,1-47.234-47.234V496.644A47.232,47.232,0,0,1,661.2,449.41h0a47.232,47.232,0,0,1,47.234,47.234v73.845A47.225,47.225,0,0,1,661.2,617.723Z",
    transform: "translate(118.692 211.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M820.933,156.774H664.4a11.391,11.391,0,0,1-11.387-11.387h0A11.391,11.391,0,0,1,664.4,134H820.933a11.391,11.391,0,0,1,11.387,11.387h0A11.391,11.391,0,0,1,820.933,156.774Z",
    transform: "translate(126.867 167.683)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792.673 304.882)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Neuroinfiammation"))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.923,272.207H259.657A11.391,11.391,0,0,1,248.27,260.82V224.427a11.391,11.391,0,0,1,11.387-11.387h79.266a11.391,11.391,0,0,1,11.387,11.387V260.82A11.384,11.384,0,0,1,338.923,272.207Z",
    transform: "translate(-36.074 137.779)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.131 401.733)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 16.416)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Perturbed \u03B1-synuclein")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(40.436 32.913)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "protestasis")))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M716.553,350.4H592.987A11.391,11.391,0,0,1,581.6,339.01V302.617a11.391,11.391,0,0,1,11.387-11.387H716.542a11.391,11.391,0,0,1,11.387,11.387V339.01A11.367,11.367,0,0,1,716.553,350.4Z",
    transform: "translate(116.977 188.919)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(711.632 490.149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mitochondrial")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(7.88 33.497)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "dysfunction")))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M853.644,499.167H710.037A11.391,11.391,0,0,1,698.65,487.78V451.387A11.391,11.391,0,0,1,710.037,440H853.644a11.391,11.391,0,0,1,11.387,11.387V487.78A11.377,11.377,0,0,1,853.644,499.167Z",
    transform: "translate(130.439 210.149)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840.837 662.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Impaired calcium")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(19.529 33.497)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "homeistasis")))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M811.424,671.994H707.387A11.391,11.391,0,0,1,696,660.607h0a11.391,11.391,0,0,1,11.387-11.387H811.424a11.391,11.391,0,0,1,11.387,11.387h0A11.391,11.391,0,0,1,811.424,671.994Z",
    transform: "translate(130.071 238.929)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(843.628 891.149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cell death")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(753.269 737.485)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Nucleus"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(866.723 761.103)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(5.75 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Caspase")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "activation")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(887.452 571.339)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Calcium")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(8.278 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "influx"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1029.988 571.339)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Calcium")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0.262 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "channel"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(906.35 343.295)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Neuron"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707.674 385.646)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reactive oxygen species"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.288 363.819)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.908)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(7.367 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Unfolded")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 28.803)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u03B1")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(9.212 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-synuclein")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.288 500.482)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Misfolding")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(2.425 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of protein")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.717 724.453)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lysosome-dependent")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(32.351 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "degradation")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(428.453 514.328)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "q",
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chaperone-mediated")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(36.017 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "autophagy")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.557 606.36)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Autophagosome"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.321 769.248)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ubiquitin-proteasome")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(50.49 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "system"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.22 871.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(16.83 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Trans-synaptic")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(12.503 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "transmission to ")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 45.161)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "unaffected neurons")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.22 669.072)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(24.653 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lysosomal ")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "autophagy system")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.401 632.422)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xDF-Pleated")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(13.699 28.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sheet")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.867 463.018)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(15.896 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Toxic")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "oligomers")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(815.141 416.595)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(17.126 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Impaired")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "mitochondrial")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(11.193 45.161)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "biogenesis"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1016.91 339.223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Activated")), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "translate(0.649 29.081)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "microglia")))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M835.236,350.4H750.627A11.391,11.391,0,0,1,739.24,339.01V302.617a11.391,11.391,0,0,1,11.387-11.387h84.608a11.391,11.391,0,0,1,11.387,11.387V339.01A11.384,11.384,0,0,1,835.236,350.4Z",
    transform: "translate(136.069 188.919)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(890.021 491.149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Oxidative")), /*#__PURE__*/React.createElement("text", {
    className: "r",
    transform: "translate(13.938 32.497)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "stress")))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M660.24,222.279,663,230.774h8.928a.585.585,0,0,1,.342,1.059l-7.219,5.249,2.756,8.495a.583.583,0,0,1-.9.649l-7.219-5.249-7.219,5.249a.584.584,0,0,1-.9-.649l2.756-8.495-7.219-5.249a.585.585,0,0,1,.342-1.059h8.928l2.756-8.495A.589.589,0,0,1,660.24,222.279Z",
    transform: "translate(123.254 179.873)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.27 449.798)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(27.752 26.784)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1.393,10.953-10.04,6.512V-4.83L1.393-.4Z",
    transform: "translate(10.473 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M0,10.953,11.433,6.512V-4.83L0-.4Z",
    transform: "translate(11.865 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M12.825-4.247,1.393-9.03-10.04-4.247,1.393.182Z",
    transform: "translate(10.473 9.417)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(19.003 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1.393,10.953-10.04,6.512V-4.83L1.393-.4Z",
    transform: "translate(10.473 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M0,10.953,11.433,6.512V-4.83L0-.4Z",
    transform: "translate(11.865 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M12.825-4.247,1.393-9.03-10.04-4.247,1.393.182Z",
    transform: "translate(10.473 9.417)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(0 19.547)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1.393,10.953-10.04,6.512V-4.83L1.393-.4Z",
    transform: "translate(10.473 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M0,10.953,11.433,6.512V-4.83L0-.4Z",
    transform: "translate(11.865 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M12.825-4.247,1.393-9.03-10.04-4.247,1.393.182Z",
    transform: "translate(10.473 9.417)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602.532 505.767)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 92.972) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 74.512) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 56.051) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 37.59) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 19.13) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(628.051 509.568)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 92.972) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 74.512) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 56.051) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 37.59) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 19.13) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(654.04 496.27)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 92.972) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 74.512) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 56.051) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 37.59) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 19.13) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.439 664.707)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 92.972) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 74.512) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 56.051) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 37.59) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(0 19.13) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(12.487 101.66) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(12.487 83.199) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(12.487 64.738) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(12.487 46.278) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(12.487 27.817) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 27.817) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(25.247 110.89) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(25.247 92.429) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(25.247 73.969) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(25.247 55.508) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(25.247 37.047) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 120.12) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 101.66) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 83.199) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 64.738) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(38.007 46.278) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M9.22,12.729,0,9.147V0L9.22,3.572Z",
    transform: "translate(0.349 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M0,12.729,9.22,9.147V0L0,3.572Z",
    transform: "translate(9.569 4.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M18.441,3.857,9.22,0,0,3.857,9.22,7.43Z",
    transform: "translate(0.349 0.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(591.366 920.748) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(591.366 910.436) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(591.366 900.124) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(591.366 889.811) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(598.343 925.601) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(598.343 915.288) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(598.343 904.977) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(598.343 894.664) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(598.343 884.351) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(605.47 930.758) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(605.47 920.445) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(605.47 910.132) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(605.47 899.82) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(605.47 889.507) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 935.913) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 925.601) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 915.288) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 904.977) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 894.664) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(591.366 879.63) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(612.598 884.483) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(632.009 925.601) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(632.009 915.288) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(632.009 904.977) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(632.009 894.664) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(632.009 884.483) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(662.686 925.601) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(662.686 915.288) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(662.686 904.977) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(662.686 894.664) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(662.686 884.483) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(646.805 934.56) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(646.805 924.248) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(646.805 913.935) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(646.805 903.622) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w",
    transform: "translate(646.805 893.443) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M5.152,7.112,0,5.111V0L5.152,2Z",
    transform: "translate(0.195 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M0,7.112l5.152-2V0L0,2Z",
    transform: "translate(5.347 2.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M10.3,2.155,5.152,0,0,2.155l5.152,2Z",
    transform: "translate(0.195 0.174)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 8.688,
    cy: 8.688,
    r: 8.688,
    transform: "translate(486.132 752.294)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.362 693.935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "y",
    cx: 22.945,
    cy: 11.752,
    rx: 22.945,
    ry: 11.752,
    transform: "translate(0 104.648)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 98.589)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 87.863)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 77.147)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 66.421)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 55.706)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(28.719 44.979)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 104.557)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 93.841)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 83.115)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 72.399)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 61.673)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(0.752 50.957)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 104.557)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 93.841)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 83.115)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 72.399)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 61.673)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(21.385 50.957)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 104.557)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 93.841)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 83.115)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 72.399)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 61.673)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 8.415,
    cy: 9.281,
    rx: 8.415,
    ry: 9.281,
    transform: "translate(11.342 50.957)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "y",
    cx: 22.159,
    cy: 11.262,
    rx: 22.159,
    ry: 11.262,
    transform: "translate(1.571 36.234)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 12.799,
    cy: 4.43,
    rx: 12.799,
    ry: 4.43,
    transform: "translate(10.932 42.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M130.835,524.956c.41-3.826-2.665-7.6-1.571-11.285a5.384,5.384,0,0,1,4.122-3.689c1.31-.239,2.858-.046,3.758-1.013a2.791,2.791,0,0,0,.592-2.141c-.2-2.209-1.981-3.929-3.815-5.17s-3.894-2.266-5.261-4.008",
    transform: "translate(-105.988 -475.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M131.968,478.47c-.695,2.505,1.127,5.056,3.245,6.57s4.646,2.471,6.479,4.327a1.809,1.809,0,0,1,.581.934,2.1,2.1,0,0,1-.171,1.013c-.364,1.013-.717,2.027-1.082,3.04",
    transform: "translate(-105.55 -478.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.655,495.26a4.23,4.23,0,0,0,1.025,4.156,41.958,41.958,0,0,0,3.336,3.018,5.087,5.087,0,0,1,1.822,3.951c-.159,1.571-1.423,2.79-2.687,3.758a29.44,29.44,0,0,1-6.081,3.587",
    transform: "translate(-103.573 -476.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M128.306,487.22c-2.289,1.8-4.669,4.293-4.213,7.174a10.667,10.667,0,0,0,2.084,4.031c1.776,2.642,3.1,5.933,2.164,8.984-1.116,3.655-4.931,5.625-7.641,8.313a2.556,2.556,0,0,0-.774,1.161,2.332,2.332,0,0,0,.273,1.526c.979,2.038,2.892,3.45,4.532,5.01s3.166,3.6,2.949,5.864",
    transform: "translate(-107.206 -477.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M124.712,499.79c.091,2.209-1.674,4.1-3.655,5.09s-4.2,1.366-6.24,2.22-4.008,2.425-4.35,4.612c-.285,1.811.6,3.587,1.458,5.2",
    transform: "translate(-108.519 -475.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M116.952,481.74a10.455,10.455,0,0,0-3.507,6.627,2.968,2.968,0,0,0,.137,1.549,4.642,4.642,0,0,0,1.435,1.469,5.973,5.973,0,0,1,2.118,3.724,4.573,4.573,0,0,1-1.423,3.974",
    transform: "translate(-108.104 -478.016)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aa",
    transform: "translate(159.737 385.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M6.71,12.043a3.927,3.927,0,0,1-1.936-1.924Q.214,2.586-3.595-5.367A5.413,5.413,0,0,1-4.358-9c3.5-1.355,7.538.82,9.679,3.906A5.3,5.3,0,0,1,6.392-2.6,2.527,2.527,0,0,1,5.367-.209,3.89,3.89,0,0,1,2.839.064a11.266,11.266,0,0,1-4.02-.979,3.819,3.819,0,0,1-2.2-3.279A5.6,5.6,0,0,1,2.793-2.156",
    transform: "translate(10.7 9.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M11.148,2.345A6.611,6.611,0,0,0,7.254.591,28.573,28.573,0,0,0,3.576.2,14.76,14.76,0,0,1,1.014.022,16.969,16.969,0,0,1-3.758-2.187,7.232,7.232,0,0,0-8.8-3.315a1.009,1.009,0,0,0-.49.251c-.41.433.1,1.1.569,1.48A11.1,11.1,0,0,0-5.477.4,3.766,3.766,0,0,0-1.856-.126a20.881,20.881,0,0,1-3.587.74A3.708,3.708,0,0,0-8.3,2.641,3.1,3.1,0,0,0-7.265,5.886,8.481,8.481,0,0,0-4.031,7.458a9.063,9.063,0,0,0,3.872.569A3.294,3.294,0,0,0,2.7,5.67C3.052,3.973,1.572,2.447.08,1.559A8.134,8.134,0,0,0-3.837.261C-7,.193-7.948,3.153-5.124,4.554c2.357,1.161,4.168-.239,6.4-.535,2.858-.387,3.985,1.469,6.6,2.243C10.522,7.048,13.631,5.089,11.148,2.345Z",
    transform: "translate(10.009 10.807)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aa",
    transform: "translate(189.328 380.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M6.71,12.043a3.927,3.927,0,0,1-1.936-1.924Q.214,2.586-3.595-5.367A5.413,5.413,0,0,1-4.358-9c3.5-1.355,7.538.82,9.679,3.906A5.3,5.3,0,0,1,6.392-2.6,2.527,2.527,0,0,1,5.367-.209,3.89,3.89,0,0,1,2.839.064a11.266,11.266,0,0,1-4.02-.979,3.819,3.819,0,0,1-2.2-3.279A5.6,5.6,0,0,1,2.793-2.156",
    transform: "translate(10.7 9.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M11.148,2.345A6.611,6.611,0,0,0,7.254.591,28.573,28.573,0,0,0,3.576.2,14.76,14.76,0,0,1,1.014.022,16.969,16.969,0,0,1-3.758-2.187,7.232,7.232,0,0,0-8.8-3.315a1.009,1.009,0,0,0-.49.251c-.41.433.1,1.1.569,1.48A11.1,11.1,0,0,0-5.477.4,3.766,3.766,0,0,0-1.856-.126a20.881,20.881,0,0,1-3.587.74A3.708,3.708,0,0,0-8.3,2.641,3.1,3.1,0,0,0-7.265,5.886,8.481,8.481,0,0,0-4.031,7.458a9.063,9.063,0,0,0,3.872.569A3.294,3.294,0,0,0,2.7,5.67C3.052,3.973,1.572,2.447.08,1.559A8.134,8.134,0,0,0-3.837.261C-7,.193-7.948,3.153-5.124,4.554c2.357,1.161,4.168-.239,6.4-.535,2.858-.387,3.985,1.469,6.6,2.243C10.522,7.048,13.631,5.089,11.148,2.345Z",
    transform: "translate(10.009 10.807)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(264.939 542.897)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(248.47 554.299)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(277.735 555.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(339.384 555.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(368.161 555.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ac",
    transform: "translate(354.768 543.304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M4.371,7.845A2.558,2.558,0,0,1,3.11,6.592Q.139,1.685-2.342-3.5a3.526,3.526,0,0,1-.5-2.366c2.277-.883,4.91.534,6.3,2.544a3.453,3.453,0,0,1,.7,1.624A1.646,1.646,0,0,1,3.5-.136,2.534,2.534,0,0,1,1.849.042,7.339,7.339,0,0,1-.769-.6,2.488,2.488,0,0,1-2.2-2.732,3.651,3.651,0,0,1,1.82-1.4",
    transform: "translate(6.97 6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M7.262,1.527A4.306,4.306,0,0,0,4.725.385a18.612,18.612,0,0,0-2.4-.252A9.615,9.615,0,0,1,.66.014,11.053,11.053,0,0,1-2.448-1.425a4.711,4.711,0,0,0-3.286-.734A.657.657,0,0,0-6.053-2c-.267.282.067.72.371.964A7.233,7.233,0,0,0-3.568.259,2.453,2.453,0,0,0-1.209-.082,13.6,13.6,0,0,1-3.546.4,2.416,2.416,0,0,0-5.407,1.72a2.016,2.016,0,0,0,.675,2.114A5.525,5.525,0,0,0-2.626,4.858,5.9,5.9,0,0,0-.1,5.229,2.146,2.146,0,0,0,1.758,3.693c.23-1.105-.734-2.1-1.706-2.678A5.3,5.3,0,0,0-2.5.17c-2.062-.045-2.678,1.884-.838,2.8C-1.8,3.723-.623,2.811.831,2.618c1.862-.252,2.6.957,4.3,1.461S8.879,3.315,7.262,1.527Z",
    transform: "translate(6.52 7.04)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aa",
    transform: "translate(167.539 361.206)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M6.71,12.043a3.927,3.927,0,0,1-1.936-1.924Q.214,2.586-3.595-5.367A5.413,5.413,0,0,1-4.358-9c3.5-1.355,7.538.82,9.679,3.906A5.3,5.3,0,0,1,6.392-2.6,2.527,2.527,0,0,1,5.367-.209,3.89,3.89,0,0,1,2.839.064a11.266,11.266,0,0,1-4.02-.979,3.819,3.819,0,0,1-2.2-3.279A5.6,5.6,0,0,1,2.793-2.156",
    transform: "translate(10.7 9.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M11.148,2.345A6.611,6.611,0,0,0,7.254.591,28.573,28.573,0,0,0,3.576.2,14.76,14.76,0,0,1,1.014.022,16.969,16.969,0,0,1-3.758-2.187,7.232,7.232,0,0,0-8.8-3.315a1.009,1.009,0,0,0-.49.251c-.41.433.1,1.1.569,1.48A11.1,11.1,0,0,0-5.477.4,3.766,3.766,0,0,0-1.856-.126a20.881,20.881,0,0,1-3.587.74A3.708,3.708,0,0,0-8.3,2.641,3.1,3.1,0,0,0-7.265,5.886,8.481,8.481,0,0,0-4.031,7.458a9.063,9.063,0,0,0,3.872.569A3.294,3.294,0,0,0,2.7,5.67C3.052,3.973,1.572,2.447.08,1.559A8.134,8.134,0,0,0-3.837.261C-7,.193-7.948,3.153-5.124,4.554c2.357,1.161,4.168-.239,6.4-.535,2.858-.387,3.985,1.469,6.6,2.243C10.522,7.048,13.631,5.089,11.148,2.345Z",
    transform: "translate(10.009 10.807)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ae",
    transform: "translate(251.926 569.502)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 18.459,
    cy: 11.9,
    rx: 18.459,
    ry: 11.9,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-10.1-5.468V.316a.816.816,0,0,0,.82.82h.547a.816.816,0,0,0,.82-.82v-5.2A2.45,2.45,0,0,1-6.128-7.245h0a2.443,2.443,0,0,1,3.1,2.357V1.125l.945-.159A.829.829,0,0,0-1.4.157v-5.83A3.256,3.256,0,0,1,1.854-8.93h0A3.256,3.256,0,0,1,5.111-5.673V.316a.816.816,0,0,0,.82.82h0a.816.816,0,0,0,.82-.82V-2.1a3.886,3.886,0,0,1,5.158-3.678h0A2.8,2.8,0,0,1,13.8-3.111V.59h1.355V-1.153a.815.815,0,0,1,1.389-.581l.922.922V2.628a2.516,2.516,0,0,1-.74,1.788h0a2.789,2.789,0,0,1-4.76-1.97V-1.118a.816.816,0,0,0-.82-.82h-.8a.816.816,0,0,0-.82.82V9.244a3.207,3.207,0,0,1-3.211,3.211h0A3.207,3.207,0,0,1,3.106,9.244v-11a.816.816,0,0,0-.82-.82h0a.816.816,0,0,0-.82.82V9.87A3.028,3.028,0,0,1-1.562,12.9h0A3.028,3.028,0,0,1-4.591,9.87V-1.221a.816.816,0,0,0-.82-.82h-.262a.816.816,0,0,0-.82.82V1.99a3.511,3.511,0,0,1-5.99,2.482h0a2.648,2.648,0,0,1-.786-1.924c.034-2.915.1-5.682-.011-5.568S-10.1-5.468-10.1-5.468Z",
    transform: "translate(16.616 10.661)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ae",
    transform: "translate(342.057 569.502)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 18.459,
    cy: 11.9,
    rx: 18.459,
    ry: 11.9,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-10.1-5.468V.316a.816.816,0,0,0,.82.82h.547a.816.816,0,0,0,.82-.82v-5.2A2.45,2.45,0,0,1-6.128-7.245h0a2.443,2.443,0,0,1,3.1,2.357V1.125l.945-.159A.829.829,0,0,0-1.4.157v-5.83A3.256,3.256,0,0,1,1.854-8.93h0A3.256,3.256,0,0,1,5.111-5.673V.316a.816.816,0,0,0,.82.82h0a.816.816,0,0,0,.82-.82V-2.1a3.886,3.886,0,0,1,5.158-3.678h0A2.8,2.8,0,0,1,13.8-3.111V.59h1.355V-1.153a.815.815,0,0,1,1.389-.581l.922.922V2.628a2.516,2.516,0,0,1-.74,1.788h0a2.789,2.789,0,0,1-4.76-1.97V-1.118a.816.816,0,0,0-.82-.82h-.8a.816.816,0,0,0-.82.82V9.244a3.207,3.207,0,0,1-3.211,3.211h0A3.207,3.207,0,0,1,3.106,9.244v-11a.816.816,0,0,0-.82-.82h0a.816.816,0,0,0-.82.82V9.87A3.028,3.028,0,0,1-1.562,12.9h0A3.028,3.028,0,0,1-4.591,9.87V-1.221a.816.816,0,0,0-.82-.82h-.262a.816.816,0,0,0-.82.82V1.99a3.511,3.511,0,0,1-5.99,2.482h0a2.648,2.648,0,0,1-.786-1.924c.034-2.915.1-5.682-.011-5.568S-10.1-5.468-10.1-5.468Z",
    transform: "translate(16.616 10.661)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(968.091 573.542)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M869.764,376.29s5.967,3.985,5.067,14.484-5.341,13.471-5.341,13.471l-48.771-.979s7.777-3.621,7.06-13.938-6.878-11.945-6.149-11.763S869.764,376.29,869.764,376.29Z",
    transform: "translate(-820.72 -372.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M862.03,372.979a6.673,6.673,0,0,1,7.459,2.847c1.173,1.97,1.264,4.407-2.266,6.582-7.06,4.338-12.492,3.985-22.08,3.621s-15.566,1.993-19.723-2.892-7.06-7.424-1.628-7.06,8.506,1.993,19.9.547A152.643,152.643,0,0,0,862.03,372.979Z",
    transform: "translate(-820.706 -372.743)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M862.03,404.951a6.673,6.673,0,0,0,7.459-2.847c1.173-1.97,1.264-4.407-2.266-6.582-7.06-4.339-12.492-3.986-22.08-3.621s-15.566-1.993-19.723,2.892-7.06,7.424-1.628,7.06,8.506-1.993,19.9-.547A152.649,152.649,0,0,1,862.03,404.951Z",
    transform: "translate(-820.706 -370.121)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M409.582,388.2c-1.139-2.7-2.277-5.386-3.428-8.085a6.794,6.794,0,0,1-.74-2.87,2.3,2.3,0,0,1,1.663-2.22,2.123,2.123,0,0,1,2.243,2.209,3.579,3.579,0,0,1-1.97,2.824,5.71,5.71,0,0,1-6.069-.41,2.359,2.359,0,0,1-1.1-1.936c.091-.957,1.036-1.56,1.663-2.3,1.446-1.719.957-4.543-.706-6.069a7.182,7.182,0,0,0-6.331-1.412,3.193,3.193,0,0,0-2.539,1.765c-.524,1.56,1.127,2.961,2.619,3.655a8.489,8.489,0,0,0,3.985.979,3.862,3.862,0,0,0,3.348-2.072c1.025-2.334-1.048-5.6.786-7.379.888-.854,2.266-.854,3.5-.8a23.833,23.833,0,0,1,4.031.41",
    transform: "translate(87.925 199.595)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M411.3,381.844l3.177-7.618a6.335,6.335,0,0,1,1.446-2.391,2.155,2.155,0,0,1,2.585-.342,1.994,1.994,0,0,1-.011,2.961,3.373,3.373,0,0,1-3.2.535,5.37,5.37,0,0,1-3.724-4.35,2.2,2.2,0,0,1,.581-2.016c.706-.569,1.731-.33,2.63-.4a4.34,4.34,0,0,0,3.621-4.464,6.78,6.78,0,0,0-3.223-5.193,2.986,2.986,0,0,0-2.858-.547c-1.389.683-1.253,2.71-.74,4.168a7.991,7.991,0,0,0,1.959,3.325,3.63,3.63,0,0,0,3.6.888c2.243-.854,3.075-4.4,5.477-4.327a4.335,4.335,0,0,1,2.835,1.822,21.369,21.369,0,0,1,2.38,2.983",
    transform: "translate(90.569 198.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M401.32,395.3l8.267-2.972a9.382,9.382,0,0,1,2.961-.706c1.036-.023,2.152.376,2.38,1.093.273.854-.957,1.719-2.209,1.765A3.939,3.939,0,0,1,409.7,393.2a3.178,3.178,0,0,1,.182-4.464,2.834,2.834,0,0,1,1.97-.922,5.464,5.464,0,0,1,2.46,1.082,6.337,6.337,0,0,0,6.286-.854,4.171,4.171,0,0,0,1.218-4.714,2.512,2.512,0,0,0-1.936-1.754c-1.651-.285-3.04.991-3.7,2.118a4.78,4.78,0,0,0-.865,2.972A2.922,2.922,0,0,0,417.6,389c2.471.615,5.785-1.082,7.709.159a2.665,2.665,0,0,1,.979,2.505,11.9,11.9,0,0,1-.273,2.972",
    transform: "translate(89.195 202.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M263.56,470.03l3.929,7.857a9.373,9.373,0,0,1,1.048,2.858c.148,1.025-.125,2.186-.8,2.494-.82.364-1.822-.752-2.016-1.981a3.955,3.955,0,0,1,.911-3.154,3.169,3.169,0,0,1,4.452-.342,2.733,2.733,0,0,1,1.139,1.845,5.248,5.248,0,0,1-.786,2.562,6.316,6.316,0,0,0,1.594,6.138,4.169,4.169,0,0,0,4.828.649,2.542,2.542,0,0,0,1.514-2.129c.091-1.674-1.344-2.9-2.539-3.428a4.82,4.82,0,0,0-3.052-.512,2.909,2.909,0,0,0-2.038,2.551c-.319,2.528,1.765,5.614.763,7.675a2.649,2.649,0,0,1-2.38,1.264,11.893,11.893,0,0,1-2.983.08",
    transform: "translate(70.086 214.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M251.58,475.225c.8-2.813,1.606-5.637,2.4-8.449a9.772,9.772,0,0,1,1.15-2.824c.592-.854,1.56-1.526,2.266-1.3.854.273.843,1.788.148,2.824a3.962,3.962,0,0,1-2.8,1.708,3.169,3.169,0,0,1-3.519-2.744,2.821,2.821,0,0,1,.4-2.141c.592-.808,1.514-.956,2.312-1.366a6.313,6.313,0,0,0,2.961-5.614,4.156,4.156,0,0,0-3.12-3.735,2.566,2.566,0,0,0-2.562.547c-1.2,1.173-.968,3.052-.433,4.247a4.816,4.816,0,0,0,1.913,2.437,2.9,2.9,0,0,0,3.223-.5c1.936-1.651,2.494-5.341,4.612-6.183a2.629,2.629,0,0,1,2.608.672,12.207,12.207,0,0,1,2.255,1.947",
    transform: "translate(68.254 211.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M299.933,479.591c-2.585-1.378-5.17-2.744-7.755-4.122a9.4,9.4,0,0,1-2.517-1.719c-.717-.752-1.161-1.845-.8-2.494.455-.774,1.924-.455,2.79.444a3.982,3.982,0,0,1,1.082,3.1,3.188,3.188,0,0,1-3.428,2.87,2.785,2.785,0,0,1-2-.843,5.36,5.36,0,0,1-.854-2.539,6.31,6.31,0,0,0-4.862-4.077,4.164,4.164,0,0,0-4.3,2.266,2.562,2.562,0,0,0,0,2.619c.888,1.412,2.778,1.583,4.065,1.31a4.8,4.8,0,0,0,2.778-1.355,2.9,2.9,0,0,0,.182-3.257c-1.207-2.243-4.691-3.553-5.067-5.807a2.657,2.657,0,0,1,1.2-2.414,11.884,11.884,0,0,1,2.38-1.8",
    transform: "translate(71.94 213.148)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ah",
    cx: 3.94,
    cy: 9.577,
    rx: 3.94,
    ry: 9.577,
    transform: "matrix(0.672, -0.74, 0.74, 0.672, 516.031, 594.839)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "ah",
    cx: 3.94,
    cy: 9.577,
    rx: 3.94,
    ry: 9.577,
    transform: "matrix(0.672, -0.74, 0.74, 0.672, 395.894, 703.874)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1000.624 369.402)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M896.353,197.251l-3.1,4.464-5.5-5.158,4.464,7.219-1.378,6.525s-2.4,4.805-6.878,2.4-6.525-6.525-7.561-8.586-7.9-10.647-7.9-10.647l2.744,8.939s-6.878-1.378-6.183-.342,3.439,2.4,6.183,3.439,6.331,1.435,5.842,2.4c-1.036,2.061-5.158,1.378-6.878,1.378s-6.525-.342-7.561-1.036a40.292,40.292,0,0,0-4.805-2.061s-3.1,3.439-1.036,3.781,2.4,1.378,6.183,1.719,6.525,1.378,8.939,1.036,1.036-1.378,4.805-.683,4.122-.683,4.805,1.036,3.439.683,1.036,3.439-2.744,2.4-6.878,2.4-6.183.342-11.683.342-9.964,1.036-11.683,2.061-5.5,2.061-.683,2.061,11.683,0,13.4-.342c0,0-11-.342-6.878,4.805s1.036-1.719,3.1-2.4,10.305-3.1,15.464-3.1,8.586,2.744,3.439,5.842-15.464,8.244-12.025,8.244,7.9-2.744,7.9-2.744-6.183,5.5-4.805,6.878,4.805.683,5.5-1.036,2.061-9.964,4.122-8.586,4.122,10.647,6.183,9.964-7.219-16.489,5.158-15.805-3.439,12.719-3.439,12.719l4.122.342,4.122-3.781,7.9,4.805,4.122-1.378s-15.464-4.122-7.9-11c0,0-4.122-3.781,13.744,3.781l8.939,2.744v-2.061s-12.025-3.781-13.061-5.842l-1.036-2.061L919,221.995l.683,4.464,2.744-3.781,11.683,2.744-10.305-5.842,14.427-1.378-6.183-1.719s-13.061,1.378-14.781,1.719-8.244,1.719-8.244,1.719l6.525-8.244s17.274-4.441,12.719-5.842c-4.464-1.378-11.342,2.061-11.342,2.061l6.183-7.9-7.561,5.5s-2.744,4.122-3.439,5.158-3.439,5.158-4.805,6.183-1.378-1.036-1.378-1.036l-2.4-4.464,9.281-12.719-4.464-.683s-5.5,12.366-7.9,13.061-7.219.342-6.183-1.036,5.5-5.5,5.5-5.5l-4.464-.683-.342-6.183",
    transform: "translate(-849.29 -193.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 3.439,
    cy: 2.744,
    rx: 3.439,
    ry: 2.744,
    transform: "translate(42.257 23.367)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(661.311 290)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M551.31,315.943V135.127A11.391,11.391,0,0,1,562.7,123.74H943.072a11.391,11.391,0,0,1,11.387,11.387v28.912",
    transform: "translate(-551.31 -123.74)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.492 35.756)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M901.26,155.914l.843-.774,3.815,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-901.26 -155.14)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(967.545 304.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M874.657,164.528V152.287A11.391,11.391,0,0,0,863.27,140.9H821.32",
    transform: "translate(-820.09 -136.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M825.25,136.81l.774.843-4.111,3.815,4.111,3.826-.774.831-5.01-4.657Z",
    transform: "translate(-820.24 -136.81)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M771.133,155.92v33.41a11.391,11.391,0,0,1-11.387,11.387h-202",
    transform: "translate(110.894 170.724)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.626 372.26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M576.073,195.98H343.127a11.391,11.391,0,0,0-11.387,11.387v3.667",
    transform: "translate(-327.083 -195.98)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.499)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M327.65,205.974l.831-.774,3.826,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-327.65 -205.2)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.686 407.503)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 151.881,
    transform: "translate(1.23 4.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M416.14,226.93l.774.843-4.111,3.815,4.111,3.826-.774.831-5.01-4.657Z",
    transform: "translate(-411.13 -226.93)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M554.18,270.08H656a11.391,11.391,0,0,0,11.387-11.387V248.9",
    transform: "translate(110.399 183.621)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.004 449.044)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 440.192,
    transform: "translate(1.23 4.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M164.38,263.41l.774.831-4.111,3.826,4.111,3.826-.774.831-5.01-4.657Z",
    transform: "translate(-159.37 -263.41)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(783.358 430.323)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y1: 47.78,
    transform: "translate(4.657 1.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M667.8,251.98l-.831.774-3.826-4.111-3.826,4.111-.831-.774,4.657-5.01Z",
    transform: "translate(-658.49 -246.97)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(909.618 543.568)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y1: 21.954,
    transform: "translate(4.657 1.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M778.685,351.43l-.831.774-3.826-4.111L770.2,352.2l-.831-.774,4.657-5.01Z",
    transform: "translate(-769.37 -346.42)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(909.618 611.128)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 29.891,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M769.37,428.774,770.2,428l3.826,4.111L777.842,428l.843.774-4.657,5.01Z",
    transform: "translate(-769.37 -428)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.88 410.122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 29.891,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.89,252.254l.831-.774,3.826,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-125.89 -251.48)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.265 564.441)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x2: 12.469,
    transform: "translate(0 4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M248.994,374.065l-.774-.831,4.111-3.826-4.111-3.826.774-.831,5.01,4.657Z",
    transform: "translate(-248.22 -364.75)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(895.715 709.797)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 47.109,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M757.16,530.544l.831-.774,3.815,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-757.16 -529.77)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.871 536.964)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 147.099,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 142.544)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.76,466.574l.831-.774,3.826,4.111,3.815-4.111.843.774-4.657,5.01Z",
    transform: "translate(-126.76 -465.8)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(895.715 795.884)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 85.517,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80.962)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M757.16,639.886l.831-.786,3.815,4.111,3.826-4.111.831.786-4.657,5Z",
    transform: "translate(-757.16 -639.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620.226 784.622)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 85.517,
    transform: "translate(4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80.974)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M515.23,629.994l.831-.774,3.826,4.111,3.826-4.111.831.774L519.887,635Z",
    transform: "translate(-515.23 -629.22)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(532.511 760.436)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 72.604,
    transform: "translate(1.23 4.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M443.2,536.87l.786.831-4.122,3.826,4.122,3.815-.786.843-5-4.657Z",
    transform: "translate(-438.2 -536.87)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(939.111 586.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 29.891,
    transform: "translate(1.23 4.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M800.269,384.5l.786.843-4.122,3.815,4.122,3.826-.786.831-5-4.657Z",
    transform: "translate(-795.27 -384.5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669.919 546.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x2: 50.081,
    transform: "translate(0 4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.537)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M599.634,358.345l-.774-.831,4.111-3.826-4.111-3.826.774-.831,5.01,4.657Z",
    transform: "translate(-598.86 -349.03)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.302 472.376)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x2: 377.221,
    transform: "translate(0 4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M488.554,293.2l-.774-.831,4.111-3.815-4.111-3.826.774-.831,5.01,4.657Z",
    transform: "translate(-487.78 -283.9)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(851.378 504.811)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 17.069,
    transform: "translate(1.241 4.657)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.756)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M728.444,314.14l-.774.831,4.111,3.815-4.111,3.826.774.831,5.01-4.657Z",
    transform: "translate(-727.67 -314.14)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M720.6,314.14l.774.831-4.111,3.815,4.111,3.826-.774.831-5.01-4.657Z",
    transform: "translate(-715.59 -314.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(799.049 407.811)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M673.35,231.28H774.627a11.391,11.391,0,0,1,11.387,11.387v50.946",
    transform: "translate(-672.12 -226.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M677.28,236.5l.774-.831-4.111-3.815,4.111-3.826-.774-.831-5.01,4.657Z",
    transform: "translate(-672.27 -227.2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.248 62.436)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M768.21,282.8l.831-.774,3.815,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-768.21 -282.03)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832.152 555.377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M701.34,356.79l23.059.171c6.286.046,11.33,7.3,11.262,16.193l-.547,72.593",
    transform: "translate(-701.34 -356.79)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.14 84.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M726.93,431.664l.843-.774,3.792,4.145,3.849-4.088.831.786-4.691,4.965Z",
    transform: "translate(-726.93 -430.89)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.309 495.609)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M158.76,304.6c1.754-.581,226.467-.137,280.021-.023a11.384,11.384,0,0,1,11.353,11.387v6.6",
    transform: "translate(-158.76 -304.303)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.716 13.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.55,317.126l.843-.786,3.815,4.122,3.826-4.122.831.786-4.657,5Z",
    transform: "translate(-410.55 -316.34)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.286 495.879)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M236.02,304.54a11.384,11.384,0,0,1,11.353,11.387v6.6",
    transform: "translate(-236.02 -304.54)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.696 13.437)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M241.9,317.126l.843-.786,3.815,4.122,3.826-4.122.831.786-4.657,5Z",
    transform: "translate(-241.9 -316.34)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.999 551.528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M521.707,353.41H486.543v88.74H298.667a11.391,11.391,0,0,0-11.387,11.387v4.487",
    transform: "translate(-282.623 -353.41)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 100.059)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M283.19,442.066l.843-.786,3.815,4.122,3.826-4.122.831.786-4.657,5Z",
    transform: "translate(-283.19 -441.28)"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y2: 32.203,
    transform: "translate(360.304 623.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M286.96,441.1v-5.272c0-6.252,4.976-11.888,11.159-11.945,26.452-.251,92.759.251,119.121,0,6.172-.057,11.148-5.694,11.148-11.945V408.65",
    transform: "translate(73.332 205.78)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.747 564.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M157.01,611.038H644.367a11.391,11.391,0,0,0,11.387-11.387V375.917a11.391,11.391,0,0,1,11.387-11.387h6.195",
    transform: "translate(-156.441 -364.53)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 242.808)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 1.139,
    height: 7.402
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(634.164 784.633)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M527.47,558.12v66.8A11.391,11.391,0,0,0,538.857,636.3H747.389a11.391,11.391,0,0,1,11.387,11.387v6.923",
    transform: "translate(-527.47 -558.12)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.649 91.951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M726.51,639.644l.831-.774,3.826,4.111,3.826-4.111.831.774-4.657,5.01Z",
    transform: "translate(-726.51 -638.87)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M813.215,156.774H683.694c-5.958,0-10.794-5.1-10.794-11.387h0c0-6.286,4.835-11.387,10.794-11.387H813.215c5.958,0,10.793,5.1,10.793,11.387h0C824.009,151.673,819.173,156.774,813.215,156.774Z",
    transform: "translate(-430.412 380.149)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.599 518.15)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Macroautophagy"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.196 373.819)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(483.604 416.149)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.604 519.15)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M803.215,156.774H703.694c-5.958,0-10.794-5.1-10.794-11.387h0c0-6.286,4.835-11.387,10.794-11.387h99.522c5.958,0,10.793,5.1,10.793,11.387h0C814.009,151.673,809.173,156.774,803.215,156.774Z",
    transform: "translate(-248.184 647.149)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(541.22 786.15)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(464.319 785.15)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lewy body"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.428 889.15)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(924.418 894.15)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(976.544 674.149)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(965.791 503.149)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(823.088 503.149)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(939.452 306.149)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "aj",
    y2: 12,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 12,
    transform: "translate(0 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDopaminergicDiagram);
export default __webpack_public_path__ + "static/media/dopaminergic-diagram.8dce2fb0dff897912cddc1f386bd0ac5.svg";
export { ForwardRef as ReactComponent };